import { render, staticRenderFns } from "./CarritoPago.vue?vue&type=template&id=c9d9f48e"
import script from "./CarritoPago.vue?vue&type=script&lang=js"
export * from "./CarritoPago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports